import { getCompanyLogo } from 'lib/api/company';
import { expressGetCompanyLogo } from 'lib/api/express';
import { showAlert } from 'lib/functions/utils';
import { Dispatch } from 'redux';
import { User } from 'services/redux/authSlice';

import { generateExtensionReportPDF } from '../../exportExtensionReport';
import type { ExtensionExportRequest } from '../types/ExtensionExportRequest';

export interface ExportExtensionReportOptions {
  dispatch: Dispatch;
  user: User;
  request: ExtensionExportRequest;
}

export const handleExportExtensionReport = async (
  options: ExportExtensionReportOptions,
): Promise<void> => {
  const { dispatch, user, request } = options;

  try {
    const imageBase64 = user?.express
      ? await expressGetCompanyLogo(dispatch, user.clientId as string)
      : await getCompanyLogo(dispatch);

    await generateExtensionReportPDF(
      request,
      user?.name ?? '',
      imageBase64,
      request.fieldVisibility,
    );

    showAlert(
      dispatch,
      'success',
      'Reporte de prórroga exportado correctamente',
    );
  } catch (error) {
    console.error(error);
    showAlert(dispatch, 'error', 'Error al exportar reporte de prórroga');
    throw error;
  }
};
